/**
 * 实时车辆展示组件
 * 用于展示停车场和路段的实时车辆数据，包括周转率、收入等信息
 */
import React, { useCallback, useEffect, useRef, useMemo, useState } from 'react'
import AlarmModal, { OnAlarmClick, AlarmType } from '@/components/AlarmModal'
import { useRequest, useInterval } from 'ahooks'
import { GetParkRank, GetRoadRank,GetRealTimeCar,GetRealTimeCarPage } from '@/services/api'
import Panel from '@/components/Panel/index'
import TopTale from '@/components/topTable'
import ImgSource from '@/assets/img/resource/zhouzhuan2.png'
import Abutton from '@/components/Abutton'
import { Spin } from 'antd'
import style from './style.module.scss'
import CustomTable from '@/components/CustomTable'
import Modal from '../../../modal'
const colorMap: Record<number, string> = {
  1:'黄牌',
  2:'蓝牌',
  3:'绿牌',
  4:'其他',
  5:'黑牌',
  6:'白牌'
}
const orderStatusMap:Record<number, string> = {
  1:"进行中", 3:"待缴费", 5:"已缴费"
}
/** 组件属性接口 */
export interface ParkingTurnoverTableProps {
  /** 区域编码 */
  areaCode?: string
}
/** 辅助函数：获取DOM元素 */
const $ = (selector: string) => document.querySelector(selector)

interface CarData {
  key?: number;
  plateNo: string;
  color: number;
  parkName: string;
  driveInTime: string;
  orderStatus: string;
}

const ParkingTurnoverTable: React.FC<ParkingTurnoverTableProps> = (props) => {
  // 状态管理
  /** 滚动间隔时间 */
  const [scrollInterval, setScrollInterval] = useState<number | null>(null)
  /** 是否允许刷新数据 */
  const [allowRefresh, setAllowRefresh] = useState(true)
  /** 告警弹窗显示状态 */
  const [alarmModal, setAlarmModal] = useState(false)
  /** 切换弹窗显示状态 */
  const [changModal, setChangModal] = useState(false)
  /** 标签页编号 */
  const [tabNoModal, setTabNoModal] = useState(0)
  /** 更多信息弹窗显示状态 */
  const [visible, setVisible] = useState(false)
  /** 告警弹窗引用 */

  const { data: roaddata=[],loading, error} = useRequest(useCallback(() => {
          return GetRealTimeCar({
            areaCode:props.areaCode,
            // limit:15,
          })
      }, [props.areaCode]), {

          formatResult: res => {
            if(res.data.list){
              // eslint-disable-next-line array-callback-return
              let data= res.data.list.filter((item:object,index:number)=>{
                if(index<15){
                  item['key']=index
                   return item
                 }
               })
               return data
              }
              return res.data.list
          },
          refreshDeps: [props.areaCode]
    })

  /** 处理表格滚动 */
  const scrollContainer = useCallback(() => {
    const container = $('.parking-turnover-table .ant-table-body')


    if (container !== null) {
      const { clientHeight, scrollHeight, scrollTop } = container
      let height = scrollTop + 1
      const top = scrollHeight - clientHeight - height
      if (top <= 0) {
        height = 0
      }
    

      if (scrollHeight <= clientHeight) {
        setScrollInterval(null)
      }

      container.scrollTo(0, height)
      
    }
  }, [])

  /** 停止自动滚动 */
  const stopTick = useCallback(() => {
    setAllowRefresh(false)
    setScrollInterval(null)
  }, [])

  /** 开始自动滚动 */
  const startTick = useCallback(() => {
    setAllowRefresh(true)
    setScrollInterval(100)
  }, [])

  // 设置自动滚动定时器
  useInterval(() => {
    scrollContainer()
  }, scrollInterval)

  // 设置数据刷新定时器
  useInterval(
    () => {
      // refresh();
    },
    allowRefresh ? 60000 : null,
  )

  if (loading) {
    return (
      <Panel title='实时车辆'>
        <div className='fetch_container' style={{ height: 240 }}>
          <Spin />
        </div>
      </Panel>
    )
  }

  if (error) {
    return (
      <Panel title='实时车辆'>
        <div className='fetch_container' style={{ height: 240 }}>
          请求错误
        </div>
      </Panel>
    )
  }

  const changdata = (val: boolean) => {
    setChangModal(val)
    setTabNoModal(val ? 1 : 0)
  }
  return (
    <Panel
      // title="实时车辆"
      title='实时车辆'

      // renderLeft={AbuttonBox}
    >
      <div className={style.parkinglotmore} onClick={() => setVisible(true)}>
        {' '}
        更多
      </div>
      <div onMouseEnter={stopTick} onMouseLeave={startTick}>
        <TopTale
          className='parking-turnover-table'
          dataSource={roaddata}
          style={{ height: '196px' }}
          rowKey='key'
          columns={[
            // {
            //   title: '排行',
            //   render:(text,record,index)=>`TOP${index+1}`,
            //   },
            { title: '车牌号', dataIndex: 'plateNo' },
            { title: '车辆颜色', dataIndex: 'color',render:(text,record,index)=>colorMap[record.color] },
            { title: '车场', dataIndex: 'parkName' },
            { title: '驶入时间', dataIndex: 'driveInTime' },
            { title: '订单状态', dataIndex: 'orderStatus',
              render:(text,record,index)=>orderStatusMap[record.orderStatus]
             },
          ]}
          scroll={{ y: 156 }}
        />
      </div>
      <Modal visible={visible} onCancel={() => setVisible(false)} width={900} height='600px'>
        <ModalContent areaCode={props.areaCode} />
      </Modal>
    </Panel>
  )
}

// 新增 ModalContent 组件
const ModalContent: React.FC<{ areaCode?: string }> = ({ areaCode }) => {
  const { data: roaddata=[], loading, error } = useRequest(useCallback(() => {
    return GetRealTimeCarPage({
      areaCode,
      pageNum:1,
      pageSize:100
    })
  }, [areaCode]), {
    formatResult: res => {
      if(res.data.list){
        let data = res.data.list.filter((item: CarData, index: number) => {
          if(index<15){
            item.key = index
            return item
          }
        })
        return data
      }
      return res.data.list
    },
    refreshDeps: [areaCode]
  })

  if (loading) {
    return <div className='fetch_container' style={{ height: 240 }}><Spin /></div>
  }

  if (error) {
    return <div className='fetch_container' style={{ height: 240 }}>请求错误</div>
  }

  return (
    <div style={{ padding: '50px 20px' }}>
      <div className={style.modal_top_title}>
        实时车辆
      </div>
      <div className={style.modal_top}>
        <div className={style.modal_top_img}>
          <span>入场图片：</span>
          {roaddata[0]?.driveInPhoto1?
          <img src={roaddata[0]?.driveInPhoto1} alt='' />
          :  
          <div className={style.no_img}>
            暂无图片
          </div>
        }
        </div>
        <div className={style.modal_top_img}>
          <span>出场图片：</span>
          {roaddata[0]?.driveOutPhoto1?
          <img src={roaddata[0]?.driveOutPhoto1} alt='' />
          :  
          <div className={style.no_img}>
            暂无图片
          </div>
        }
        </div>
      </div>
      <TopTale
        dataSource={roaddata}
        style={{ height: '396px' }}
        rowKey='key'
        columns={[
          { title: '车牌号', dataIndex: 'plateNo' },
          { title: '车辆颜色', dataIndex: 'color',render:(text,record,index)=>colorMap[record.color] },
          { title: '车场', dataIndex: 'parkName' },
          { title: '驶入时间', dataIndex: 'driveInTime' },
          { title: '订单状态', dataIndex: 'orderStatus' ,
            render:(text,record,index)=>orderStatusMap[record.orderStatus]
          },
        ]}
        scroll={{ y: 156 }}
      />
    </div>
  )
}

export default ParkingTurnoverTable
